import { Order, SortParams } from "@/types/types";

/** Default inbox sort (recency) — mirrors the slice's initial `sortingInbox`. */
const DEFAULT_INBOX_SORT: SortParams = { sortBy: "updatedAt", sortOrder: Order.DESC };

/**
 * Column-header 3-state sort cycle: re-selecting a field that is already sorted DESC returns to the
 * default sort (so a third header click clears back to default). Any other change is applied as-is.
 */
export const resolveInboxSorting = (current: SortParams, next: SortParams): SortParams => {
	const togglingBackToDefault =
		current.sortOrder === Order.DESC &&
		next.sortOrder === Order.ASC &&
		next.sortBy === current.sortBy;

	return togglingBackToDefault ? DEFAULT_INBOX_SORT : next;
};
